import { Button, Modal, Spinner } from "@aqar-app/react-ui";
import React, { useEffect, useRef, useState } from "react";
import logger from "@/console";
import css from "@/components/Listing/ListingScreen/.module.scss";
import Icon from "@/components/icon";

export const ClassicModal = ({
  body,
  title,
  ok,
  cancel = { label: "إلغاء", cb: Modal.close },
  close = true,
  onClose,
  newDesign,
  closeButtonStyle = {},
} = {}) => {
  const footer = useRef(null);
  const [loading, setLoading] = useState("");
  useEffect(() => {
    const parent = footer.current?.parentElement;
    if (!parent) return;
    function loadChange(e) {
      setLoading(e.detail?.loading);
      logger.log(e);
    }
    parent.addEventListener("loadchange", loadChange);
    return () => parent.removeEventListener("loadchange", loadChange);
  }, []);

  return (
    <Modal.ClassicOverlay
      dir="rtl"
      className={`${css.classicModal} ${newDesign ? css.newDesign : ""}`}
    >
      <div className={`${css.title} ${newDesign ? css.newDesign : ""}`}>
        <p>{title}</p>
        {close ? (
          <Modal.CloseButton
            style={closeButtonStyle}
            disabled={!!loading}
            onClick={(e) => {
              Modal.close(e);
              onClose?.(e);
            }}
          />
        ) : null}
      </div>
      <div className={`${css.body} ${newDesign ? css.newDesign : ""}`}>
        {body}
        {loading === "body" ? (
          <Spinner className={css.spinner} size="small" />
        ) : null}
      </div>
      {ok || cancel ? (
        <div ref={footer} className={css.footer}>
          {ok && !ok.jsx && (
            <Button
              theme={ok?.theme || "primary"}
              outline={ok?.outline ?? !!newDesign}
              disabled={!!loading}
              onClick={ok.cb}
            >
              {loading === "ok" && <Spinner size="small" />}
              {ok.label}
            </Button>
          )}
          {ok?.jsx}
          {cancel && !cancel.jsx && (
            <Button
              disabled={!!loading}
              outline={!!newDesign}
              onClick={cancel.cb}
              theme={cancel?.theme || "default"}
            >
              {loading === "cancel" && <Spinner size="small" />}
              {cancel.label}
            </Button>
          )}
          {cancel?.jsx}
        </div>
      ) : null}
    </Modal.ClassicOverlay>
  );
};
ClassicModal.loading =
  (value = true) =>
  (e) =>
    e.target.dispatchEvent(
      new CustomEvent("loadchange", {
        detail: { loading: value },
        bubbles: true,
      }),
    );
